module.exports = __webpack_public_path__ + "static/media/matilde-sleepy.8a4f6da8.png";